import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

interface SemicircleProgressProps {
  currentPoints: number;
  totalPoints?: number;
}

const SemicircleProgress: React.FC<SemicircleProgressProps> = ({ currentPoints, totalPoints = 1000 }) => {
  const percentage = ((currentPoints / totalPoints) * 100).toFixed(1);

  const data = {
    datasets: [
      {
        data: [currentPoints, totalPoints - currentPoints],
        backgroundColor: ["#C71F2C", "#1f7bf414"],
        borderWidth: 0,
        circumference: 180,
        rotation: 270,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    cutout: "85%",
  };

  return (
    <div className="w-28 xl:w-44 -my-5">
      <div className="relative">
        <Doughnut data={data} options={options} />
        <div className="absolute bottom-8 xl:bottom-4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <p className="xl:text-3xl font-semibold">{percentage}%</p>
        </div>
      </div>
    </div>
  );
};

export default SemicircleProgress;
